import React from 'react';
import Button from '../Button'
import styled from 'styled-components'
import PageTitle from '../PageTitle';

const FormHeaderRow = styled.div`
    
    display: flex;
    justify-content: space-between;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 8px;
`;

const FormHeader =({ title, onCreateForm, buttonName, renderCreate}) => (
    <FormHeaderRow>
        <PageTitle title={title} />
        { renderCreate &&
            <Button onClickHandler={onCreateForm}>{buttonName}</Button>
        }
    </FormHeaderRow>
);

export default FormHeader;
